import sidebars from './modules/sidebars';
import forms from './modules/forms';

export const state = () => ({
  boardingShown: false,
  modalConfig: null,
  needUpdatePhoto: false,
  iframeOpen: false,
  galleryQuery: '/gallery?ignoreBanner=true'
})
export const mutations = {
  closeIframe(state) {
    state.iframeOpen = false;
  },
  openIframe(state) {
    state.iframeOpen = true;
  },
  changeNeedUpdatePhoto(state, value = false) {
    state.needUpdatePhoto = value;
  },
  getConfigForSystemModal(state, obj = null) {
    state.modalConfig = obj
  },
  boardingClosed(state) {
    state.boardingShown = true
  },
  changeGalleryQuery(state, value) {
    state.galleryQuery = value
  }
}

export const getters = {
  getBoardingShown: (state) => {
    return state.boardingShown
  },
  getModalConfig: (state) => {
    return state.modalConfig
  },
  getNeedUpdatePhoto: (state) => {
    return state.needUpdatePhoto
  },
  getIframeOpen: (state) => {
    return state.iframeOpen
  },
  getGalleryQuery(state) {
    return state.galleryQuery
  }
}
export const modules = {
  sidebars: sidebars,
  forms: forms,
}
